<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="600px"
    >
        <template v-slot:form>
            <v-container>
                <v-row>
                    <v-col cols="12" sm="8">
                        <v-text-field 
                            autofocus 
                            :error="!!errors.label" 
                            :error-messages="errors.label" 
                            v-model="model.label" 
                            label="Rótulo *"
                            :counter="100"
                            :rules="[v => (!v || v.length <= 100) || 'Máximo de 100 caracteres']"
                            placeholder="Ex: Li e Concordo"
                            persistent-placeholder
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <s-text-field 
                            code 
                            :error-messages="errors.code" 
                            v-model="model.code" 
                            label="Código *"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12">
                        <v-textarea
                            :error="!!errors.description" 
                            :error-messages="errors.description" 
                            v-model="model.description" 
                            label="Descrição"
                            :counter="255"
                            rows="2"
                            :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres']"
                            outlined
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <s-text-field 
                            :error-messages="errors.color" 
                            v-model="model.color" 
                            label="Cor"
                            placeholder="Ex: success, error, primary"
                            persistent-placeholder
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <s-text-field 
                            :error-messages="errors.icon" 
                            v-model="model.icon" 
                            label="Ícone"
                            placeholder="Ex: mdi-check, mdi-close"
                            persistent-placeholder
                        />
                    </v-col>
                </v-row>
                <v-divider class="my-4" />
                <v-row>
                    <v-col cols="12">
                        <span class="subtitle-2 grey--text text--darken-1">Configurações de Aceite</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <s-switch 
                            inset 
                            text-helper="Quando marcado, esta opção representa um aceite válido e o status será 'Assinado/Concluído'" 
                            v-model="model.is_valid_acceptance" 
                            label="Aceite Válido"
                            color="success"
                        />
                    </v-col>
                    <v-col cols="12" sm="6">
                        <s-switch 
                            inset 
                            text-helper="Quando marcado, o usuário será obrigado a preencher uma justificativa ao selecionar esta opção" 
                            v-model="model.require_justification" 
                            label="Exigir Justificativa"
                            color="warning"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-switch 
                            color="purple" 
                            inset 
                            v-model="model.active" 
                            label="Ativo"
                        />
                    </v-col>
                </v-row>
                <!-- Preview da opção -->
                <v-row v-if="model.label">
                    <v-col cols="12">
                        <v-card outlined class="pa-3">
                            <v-card-subtitle class="pb-1">Pré-visualização</v-card-subtitle>
                            <v-card-text>
                                <v-chip 
                                    :color="model.color || 'grey'" 
                                    :outlined="!model.is_valid_acceptance"
                                    small
                                    class="mr-2"
                                >
                                    <v-icon v-if="model.icon" left small>{{ model.icon }}</v-icon>
                                    {{ model.label }}
                                </v-chip>
                                <v-chip v-if="model.is_valid_acceptance" color="success" x-small outlined class="ml-2">
                                    <v-icon x-small left>mdi-check-circle</v-icon>
                                    Aceite Válido
                                </v-chip>
                                <v-chip v-if="model.require_justification" color="warning" x-small outlined class="ml-2">
                                    <v-icon x-small left>mdi-text-box</v-icon>
                                    Requer Justificativa
                                </v-chip>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length" :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterTermOption",
    data: () => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
    }),

    created(){
        
    },

    computed: {
        ...mapState('auth', ['acesso']),
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};

                if(!this.model.id){
                    this.model.active = true;
                    this.model.is_valid_acceptance = false;
                    this.model.require_justification = false;
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-format-list-checks"
        },
        title: {
            type: String,
            default: "Cadastro de Opção de Termo"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('term', ['ActionUpdateTermOption', 'ActionCreateTermOption']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            if(edit) {
                this.ActionUpdateTermOption(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateTermOption(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>
